import { BaseBuyBonusPopup } from './BaseBuyBonusPopup';
import { buyBonusResources } from '../../../core/gameConstants';
import { gameConfig } from '../../../core/configs';

class BuyBonusDesktopPopup extends BaseBuyBonusPopup {
  constructor() {
    super();
    this.loader = this.createLoader();
    this.resources = null;
  }

  async loadResource() {
    if (!this.resources) {
      const { res } = await super.loadResource(buyBonusResources, this.loader);
      this.resources = res;
    }
    return this.resources;
  }

  async onLoad() {
    return this.loadResource();
  }

  executeWeb({ root }) {
    return this.loadResource([]).then(() => {
      const container = this.getPopup({
        sizes: {
          width: 1050,
          parentWidth: gameConfig.width,
          parentHeight: gameConfig.height,
          padding: gameConfig.width * .145,
          scale: 1.4,
          percent: 18,
        },
        onClick: this.onClick(),
      });
      root.addChild(container);
    });
  }
}

export const buyBonusDesktopPopup = new BuyBonusDesktopPopup();
